import clsx from "classnames";
import { useLocale } from "@/hooks/useLocale";
import { Container } from "react-bootstrap";

export const SimplePageContentSection = ({ className, page }) => {
  const locale = useLocale();

  if (!page[`body_${locale}`]) {
    return null;
  }

  return (
    <div className={clsx(className)}>
      <Container>
        <div dangerouslySetInnerHTML={{ __html: page[`body_${locale}`] }} />
      </Container>
    </div>
  );
};

SimplePageContentSection.defaultProps = {
  className: "py-4 py-md-5",
};
